module.exports = __webpack_public_path__ + "static/img/3137_phase_function_Paper_Points.bc00898.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3137_phase_function_Paper_Points.png
// module id = sYYK
// module chunks = 0